interface Props {
  show: boolean;
  children: React.ReactNode;
}

/** The shimmer itself; fills its nearest positioned ancestor. */
export const AIShimmerLayer = () => (
  <div className="absolute inset-0 rounded-sxs overflow-hidden">
    <div className="absolute inset-0 moving-gradient-bg opacity-20 animate-pulse" />
    <div
      className="absolute inset-0 opacity-60"
      style={{
        background: "linear-gradient(90deg, transparent 0%, rgba(167,139,250,0.3) 50%, transparent 100%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite",
      }}
    />
  </div>
);

export const AIShimmerOverlay = ({ show, children }: Props) => {
  return (
    <div className={`relative ${show ? "pointer-events-none" : ""}`}>
      {children}
      {show && <AIShimmerLayer />}
    </div>
  );
};
